import React, { Suspense, useMemo } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './RoomUtils';
import { useIntl } from 'react-intl';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { FilterObjectsUIProvider, useFilterObjectsUIContext } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { SpecificationsUIProvider, useSpecificationsUIContext } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';


// export const RoomPage = () => {
export const RoomDialogPage = () => {

  const specsUIContext = useSpecificationsUIContext();
  const filterUIContext = useFilterObjectsUIContext();
  const specsUIProps = useMemo(() => {
    return {
      id: specsUIContext.selectedId,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
      show: specsUIContext.showRoomsDialog,
      onHide: specsUIContext.closeRoomsDialog,
      queryParams: filterUIContext.queryParams,
      setIds: specsUIContext.setIds,
    };
  }, [specsUIContext, filterUIContext]);

  const { floorState } = useSelector(
    (state) => ({ floorState: state.floors }),
    shallowEqual
  );
  const { currentState } = useSelector(
    (state) => ({ currentState: state.rooms }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/building")) {
    const temp = menuList.find(q => q.url == "/building")
    isFullAccess = temp.isFullAccess;
  }

  const intl = useIntl();
  // const dispatch = useDispatch();
  const backToObjectsList = () => {
    // dispatch(actions.fetchObjectByParentId("api/BankAccountSubGroup", "bankAccountSubGroups", undefined, "subGroupId"));
    // history.push(basePath);
    specsUIProps.onHide()
  };


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <SpecificationsUIProvider currentParentId={specsUIProps.id} currentParentName="floorId" initSpecification={initObject}>
        <Card>
          {/* <CardHeader title={`مدیریت اتاق های طبقه ${floorState.entities.find(q => q.id === specsUIProps.id).title} - بلوک ${floorState.entities.find(q => q.id === specsUIProps.id).buildingTitle}`} > */}
          <CardHeader title={`مدیریت اتاق های طبقه ${floorState.entities.find(q => q.id === specsUIProps.id).title} `} >
            <CardHeaderToolbar>
              <button
                type="button"
                onClick={backToObjectsList}
                className="btn btn-light"
              >
                <i className="fa fa-arrow-left"></i>
                {"بازگشت به طبقات"}
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>

            <Specifications
              // showTitle={` طبقه ${floorState.entities.find(q => q.id === specsUIProps.id).title} - بلوک ${floorState.entities.find(q => q.id === specsUIProps.id).buildingTitle}`}
              showTitle={` طبقه ${floorState.entities.find(q => q.id === specsUIProps.id).title} `}
              api="api/room"
              reduxName="rooms"
              columns={columns}
              prepareFilter={prepareFilter}
              filterInitialValues={filterInitialValues}
              filterFields={filterFields}
              haveFullAccess={false}
              haveAccess={false}
              haveAddAction={true}
              haveDeleteAction={true}
              haveEditAction={true}
              ObjectEditSchema={ObjectEditSchema}
              formFields={formFields}
              haveHardDelete={true}
              isFullAccess={isFullAccess}
            />

          </CardBody>
        </Card>
      </SpecificationsUIProvider>
    </FilterObjectsUIProvider>
  )


}

export default RoomDialogPage



